import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    IButtonIconOnlyBusinessLogic,
    IButtonIconOnlyProperties,
    createButtonIconOnly,
} from '@vfde-brix/ws10/button-icon-only';
import * as mapDispatch from '../action';
import { debugInfo } from '../../../utils/debug';
import { CaptchaId } from '../../../enums/elementId';
import { CaptchaMediaType } from '../enum';

/**
 * Create an image/audio element with the captcha url as source
 * but check if it already exists first
 * as we want to be able to generate a new one on refresh button click
 * and only change the source value
 */
export const createCaptcha = (
    mediaType: CaptchaMediaType | undefined,
    url: string,
    action: typeof mapDispatch,
    formElements: any,
) => {
    if (!mediaType) {
        return;
    }

    const { captchaAudioBtn, captchaRefreshBtn } = formElements;
    const captchaContainer = document.getElementById(CaptchaId.CONTAINER_CAPTCHA) as HTMLDivElement;
    const captchaImageContainer =
        document.getElementById(CaptchaId.CONTAINER_CAPTCHA_IMAGE) as HTMLDivElement;
    const captchaResultInput = document.getElementById(CaptchaId.INPUT_CAPTCHA_RESULT) as HTMLInputElement;
    let captchaImage = document.getElementById(CaptchaId.CAPTCHA_IMAGE_ELEMENT) as HTMLImageElement;
    let captchaAudio = document.getElementById(CaptchaId.CAPTCHA_AUDIO_ELEMENT) as HTMLAudioElement;
    let contentSwitchBtnProps: IButtonIconOnlyProperties = {
        stdIconName: 'sound-active',
        optSize: 'large',
        optColor: 'secondary',
        stdAriaLabel: '',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    switch (mediaType) {
        case CaptchaMediaType.HEADER_IMAGE: {
            if (!captchaImage) {
                captchaImage = document.createElement('img');
                captchaImage.setAttribute('id', CaptchaId.CAPTCHA_IMAGE_ELEMENT);
                captchaImageContainer.prepend(captchaImage);
            }
            if (captchaAudio) {
                captchaAudio.style.display = 'none';
            }

            captchaImage.src = url;
            captchaImageContainer.style.display = 'block';

            contentSwitchBtnProps = {
                ...contentSwitchBtnProps,
                stdIconName: 'sound-active',
                business: {
                    onClick: () => {
                        action.getCaptcha(CaptchaMediaType.HEADER_AUDIO);
                    },
                },
            };
            break;
        }
        case CaptchaMediaType.HEADER_AUDIO: {
            if (!captchaAudio) {
                captchaAudio = document.createElement('audio');
                captchaAudio.setAttribute('id', CaptchaId.CAPTCHA_AUDIO_ELEMENT);
                captchaContainer.prepend(captchaAudio);
            }
            captchaImageContainer.style.display = 'none';
            captchaAudio.style.display = 'block';

            captchaAudio.src = url;
            captchaAudio.controls = true;
            captchaAudio.play();

            contentSwitchBtnProps = {
                ...contentSwitchBtnProps,
                stdIconName: 'photos',
                business: {
                    onClick: () => {
                        action.getCaptcha(CaptchaMediaType.HEADER_IMAGE);
                    },
                },
            };
            break;
        }
    }

    captchaAudioBtn.update(contentSwitchBtnProps);

    const refreshBtnBusiness: IButtonIconOnlyBusinessLogic = {
        onClick: () => {
            URL.revokeObjectURL(url);
            action.getCaptcha(mediaType);
            captchaResultInput.value = '';
        },
    };

    captchaRefreshBtn.update({
        stdIconName: 'refresh',
        optSize: 'large',
        business: refreshBtnBusiness,
    });
};

/** Mount captcha elements */
export const mountCaptchaElements = (actions: any) => {
    const containerRefreshBtn = document.getElementById(CaptchaId.CONTAINER_CAPTCHA_REFRESH);
    const containerAudioBtn = document.getElementById(CaptchaId.CONTAINER_CAPTCHA_AUDIO);

    if (!containerRefreshBtn) {
        debugInfo('Container with id not found: ', CaptchaId.CONTAINER_CAPTCHA_REFRESH);
        return;
    }

    if (!containerAudioBtn) {
        debugInfo('Container with id not found: ', CaptchaId.CONTAINER_CAPTCHA_AUDIO);
        return;
    }

    const audioBtnBusiness: IButtonIconOnlyBusinessLogic = {
        onClick: () => {
            actions.getCaptcha(CaptchaMediaType.HEADER_AUDIO);
        },
    };

    const audioBtnProps: IButtonIconOnlyProperties = {
        stdIconName: 'sound-active',
        optSize: 'large',
        optColor: 'secondary',
        stdAriaLabel: '',
        business: audioBtnBusiness,
    };

    const refreshBtnProps: IButtonIconOnlyProperties = {
        stdIconName: 'refresh',
        optSize: 'large',
        optColor: 'secondary',
        stdAriaLabel: '',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    const captchaRefreshBtn = createButtonIconOnly(containerRefreshBtn, refreshBtnProps);
    const captchaAudioBtn = createButtonIconOnly(containerAudioBtn, audioBtnProps);

    return { captchaAudioBtn, captchaRefreshBtn };
};
